import { API_SIMPLE, CLIENT_ID, DEV_MODE, HOSTNAME } from '../const';

import request from './request';

const analyticsUrl = DEV_MODE
	? `https://${HOSTNAME}${API_SIMPLE}`
	: `https://${CLIENT_ID}.${HOSTNAME}${API_SIMPLE}`;
export const sendAnalytics = () =>
	request.post(analyticsUrl + '/analytics/ui', { action: 'OPEN_MENU' });
